var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGarbage = function SvgGarbage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 41.336 41.336"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.335 5.668h-8.167V1.5a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v4.168H5.001a2 2 0 0 0 0 4h2.001v29.168a2.5 2.5 0 0 0 2.5 2.5h22.332a2.5 2.5 0 0 0 2.5-2.5V9.668h2.001a2 2 0 0 0 0-4M14.168 35.67a1.5 1.5 0 0 1-3 0v-21a1.5 1.5 0 0 1 3 0zm8 0a1.5 1.5 0 0 1-3 0v-21a1.5 1.5 0 0 1 3 0zm3-30.002h-9V3h9zm5 30.002a1.5 1.5 0 0 1-3 0v-21a1.5 1.5 0 0 1 3 0z"
  })));
};
export default SvgGarbage;